<template>
  <div>
    <v-tabs show-arrows height="32" :color="$store.state.isMobileView ? 'primary' : 'grey lighten-3'" slider-size="2"
      class="primaryColor text-capitalize" v-model="activeTab">
      <v-tab v-for="(tab, index) in tabs" :key="index" :href="tab.link" class="fsize12 primaryColor">{{ tab.name }}</v-tab>
      <div class="d-flex justify-end align-center w-100 px-2">
        <svg @click="copyTextFunc()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img"
          aria-hidden="true" class="v-icon__svg cursor" style="font-size: 16px; height: 16px; width: 16px;">
          <path
            d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z">
          </path>
        </svg>
        <div class="fsize13 mx-1 cursor" @click="copyTextFunc()">{{ copyText }}</div>
      </div>
    </v-tabs>
    <v-tabs-items color="grey" class="primaryColor fsize14 " v-model="activeTab">
      <v-card>
        <v-tab-item :transition="false" id="Curl">
          <div class="codeBlock" v-html="curlCode"></div>
        </v-tab-item>
        <v-tab-item :transition="false" id="Java">
          <div class="codeBlock" v-html="javaCode"></div>
        </v-tab-item>
        <v-tab-item :transition="false" id="JavaScript">
          <div class="codeBlock" v-html="jsCode"></div>
        </v-tab-item>
        <v-tab-item :transition="false" id="Python">
          <div class="codeBlock" v-html="pythonCode"></div>
        </v-tab-item>
        <v-tab-item :transition="false" id="Csharp">
          <div class="codeBlock" v-html="csharpCode"></div>
        </v-tab-item>
        <v-tab-item :transition="false" id="Response">
          <div class="codeBlock" v-html="responseBlock"></div>
        </v-tab-item>
        <v-tab-item :transition="false" id="Error">
          <div class="codeBlock" v-html="errorBlock"></div>
        </v-tab-item>
      </v-card>
    </v-tabs-items>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
export default {
  props: ["javaCode", "jsCode", "curlCode", 'pythonCode', 'csharpCode', 'responseBlock', 'errorBlock'],
  data: () => ({
    activeTab: "Java",
    tabs: [
      { name: "C#", link: "#C#" },
      { name: "Curl", link: "#Curl" },
      { name: "Java", link: "#Java" },
      { name: "JavaScript", link: "#JavaScript" },
      { name: "Python", link: "#Python" },
      { name: "Response", link: "#Response" },
      { name: "Error", link: "#Error" }
    ],
    copyText: "Copy",
  }),
  methods: {
    copyTextFunc() {
      var id =
        this.activeTab == "JavaScript"
          ? "JavaScript"
          : this.activeTab == "Java"
            ? "Java"
            : this.activeTab == "Curl" ? "Curl" : this.activeTab == "Python" ? "Python" : this.activeTab == 'Response' ? 'Response' :  this.activeTab == 'Error' ? 'Error' : 'Csharp';
      var textContent = document.getElementById(id).innerText;
      navigator.clipboard.writeText(textContent);
      this.copyText = "Copied!";
      setTimeout(() => {
        this.copyText = "Copy";
      }, 1700);
    },
  },
};
</script>

